module.exports = __webpack_public_path__ + "static/media/current_pin.63e3cb43.png";